import React from 'react'
import Box from '../components/Box'

export default function Section14() {
    return (
        <div className="section">
            <h2>Section XIV: Class / Student / Assignment Report Generators</h2>
            <p>This view is used to create reports for classes, students, or assignments. It is divided into four tables as follows:</p>
            <Box sectionData={'start'} title={'Classes / Class'} body={`This is a list of all recorded classes separated by term.  For class reports, tap to select or deselect a 
            class. For student reports, tap to select a class and populate the list of students.`} />

            <Box title={'Report Types'} body={`There are five reports that can be created for each class: 
            • Attendance: A report showing all students and their count for each attendance entry type. 
            • Roster: A class roster with all student names, IDs, email addresses, and notes (if selected). 
            • Photo Roster: A class roster with all student photos included on a grid. 
            • Behavior: A report listing all behavior marks for a class. 
            • Grades: A report listing each student and their overall and, if relevant, category grades and 
            point totals. 
            There are four reports that can be created for each student: 
            • Attendance: A report that shows an overall summary and detailed list of all attendance entries. 
            • Grade: A report showing a grade summary and detailed information about all entered grades. 
            • Behavior: A report with all behavior marks for the indicated student. 
            • Summary: A report that shows a summary of grade, attendance, behavior, and missing 
            assignments. 
            There are three reports that can be created for each assignment: 
            • Scores (.gbs): A GradeBook Pro score import formatted file.  This file can be used to import 
            scores to another assignment. 
            • Scores (.prn): A space-space delimited score report file that can be used to import into other 
            apps (like Edline). 
            • Scores (.pdf): A pdf formatted, printer ready report containing all student scores for the 
            selected assignment.`} />


            <Box title={'Report Formats'} body={`There are two report formats available: 
            • PDF: A formatted file best suited for viewing or printing. This is the only option for student 
            reports. 
            • CSV: An export file best suited for opening in a spreadsheet editor.  These files are most useful 
            for archiving data or performing calculations on entered data and are only available for class 
            reports. `} />


            <Box sectionData={'end'} title={'Destinations'} body={`Choose any of the following destinations (if available): 
            • Device Only: The files are created and left in the devices /Documents/Reports/ directory.  Open 
            them with the “Open Existing Report” button on the Data view or use iTunes File Sharing to 
            transfer them to another device. 
            • Email: Create the reports and attach them to an unaddressed email message. 
            • Dropbox: Create the files and upload them to the /GradeBook Pro/Reports/ directory of the 
            linked Dropbox account. 
            • Preview: Create the files and open all of them in a preview window for viewing or printing. 
            • Student Email: This destination is only available for student reports.  If selected, the app will 
            create an email with the report attached and addressed to the student email address(es) 
            recorded on the class roster.  Each message has to be sent individually but they will be 
            presented in succession until complete or cancelled. 
            • Import Directory: Files are created and made available for import. 
            • Export: Created files are available to be shared via AirDrop, email, and other available sharing 
            services.  
            Make the appropriate selections and tap the “Create Reports” button to begin creating the reports.`} />
        </div>
    )
}
